// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { documentDesignManifest } from './document-design';
import { documentTemplatesManifest } from './document-templates';

/** Група модулів «Документи» (Documents): 2 модулів. */
export const documentsGroup: IModuleGroupManifest = {
  key: 'documents',
  category: 'Documents',
  name: { en: 'Documents', uk: 'Документи' },
  sort: 1,
  modules: [documentDesignManifest, documentTemplatesManifest],
};
